export default __webpack_public_path__ + "static/media/ic-other-notification-01.ea0d6088.svg";